<template>
  <v-card>
     <v-card-title>
       <v-icon x-large>mdi-xbox-controller-menu</v-icon>
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="menus"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900px">
          <!--<template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field :disabled="true" v-model="editedItem.ApiMenu_id" 
                        label="Menu ID"  :counter="50" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiMenu_Title" :rules="TituloRules" 
                        label="Menu Titulo"  :counter="50" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiMenu_Icon" :rules="IconoRules" 
                        label="Menu Icono"  :counter="50" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiMenu_Link" :rules="LinkRules" 
                        label="Menu Link"  :counter="50" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                     <!--<img :src="image" width="40" height="40"/>
                      <v-file-input v-model="editedItem.ApiMenu_Image"
                        accept="image/*"
                        @change="handleFileUpload"
                        :rules="ImageRules" label="Select Image File..." 
                        prepend-icon="mdi-camera"
                      ></v-file-input>-->
                      <v-text-field v-model="editedItem.ApiMenu_Image" :rules="ImageRules" 
                      label="Menu Imagen" :counter="50" required prepend-icon="mdi-camera"></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">NUEVO MENU</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiMenu_id" :rules="IDRules"
                        label="Menu ID"  :counter="50" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiMenu_Title" :rules="TituloRules" 
                        label="Menu Titulo"  :counter="50" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiMenu_Icon" :rules="IconoRules" 
                        label="Menu Icono"  :counter="50" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiMenu_Link" :rules="IconoRules" 
                        label="Menu Link"  :counter="50" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                     <!--<img :src="image" width="40" height="40"/>
                      <v-file-input v-model="editedItem.ApiMenu_Image"
                        accept="image/*"
                        @change="handleFileUpload"
                        :rules="ImageRules" label="Select Image File..." 
                        prepend-icon="mdi-camera"
                      ></v-file-input>-->
                      <v-text-field v-model="editedItem.ApiMenu_Image" :rules="ImageRules" 
                      label="Menu Imagen" :counter="50" required prepend-icon="mdi-camera"></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.ApiMenu_Image="{ item }">
    <v-avatar>
      <img
        :src="require('../../static/img/'+item.ApiMenu_Image)"
        alt="John"
      >
    </v-avatar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    search: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    valid: true,
    image : null,
    file: null,
    imageUrl: null,
    headers: [
      { text: 'Menu ID', value: 'ApiMenu_id' },
      { text: 'Menu Titulo', value: 'ApiMenu_Title' },
      { text: 'Menu Icono', value: 'ApiMenu_Icon' },
      { text: 'Menu Link', value: 'ApiMenu_Link' },
      { text: 'Menu Imagen', value: 'ApiMenu_Image' },
      { text: 'Actions', value: 'action', sortable: false },
    ],
    menus: [],
    editedIndex: -1,
    editedItem: {
      ApiMenu_id: '',
      ApiMenu_Title: "",
      ApiMenu_Icon: "",
      ApiMenu_Link: "",
      ApiMenu_Image: "default.jpg",
    },
    defaultItem: {
      ApiMenu_id: '',
      ApiMenu_Title: "",
      ApiMenu_Icon: "",
      ApiMenu_Link: "",
      ApiMenu_Image: "default.jpg",
    },
    IDRules: [
      v => !!v || 'Menu ID es requerido',
      v => (v && v.length <= 50) || 'Menu ID debe tener menos de 50 caracteres',
    ],
    TituloRules: [
      v => !!v || 'Menu Titulo es requerido',
      v => (v && v.length <= 50) || 'Menu Titulo debe tener menos de 50 caracteres',
    ],
    IconoRules: [
      v => !!v || 'Menu Icono es requerido',
      v => (v && v.length <= 50) || 'Menu Icono debe tener menos de 50 caracteres',
    ],
    LinkRules: [
      v => !!v || 'Menu Link es requerido',
      v => (v && v.length <= 50) || 'Menu Link debe tener menos de 50 caracteres',
    ],
    ImageRules: [
      v => !!v || 'Menu Imagen es requerido',
    ],
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Menu' : 'Editar Menu'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  created () {
    this.initialize()
  },

  methods: {
    handleFileUpload(e){
        const reader = new FileReader()
        this.imageUrl = URL.createObjectURL(this.editedItem.ApiMenu_Image)
        reader.readAsDataURL(this.editedItem.ApiMenu_Image)
        reader.onload = e => {
         this.image = e.target.result
         this.editedItem.ApiMenu_Image.name
        }      
    },
    initialize () {
      axios.post(this.api_tool_url + '/get_menu', {}, this.config)
      .then(response => {
        this.menus = response.data.ResultRows
      })
      .catch(error => {
        this.menus = []
        alert(error.response.data.message)
      })
    },

    newtItem (item) {
      this.image = null
      this.editedIndex = this.menus.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_new = true
    },

    editItem (item) {
      this.image = null
      this.editedIndex = this.menus.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.menus.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.deleteMenu(index)
    },

    deleteMenu(index) {
      let menu_tmp = this.menus[index]
      delete menu_tmp.ApiMenu_Title
      delete menu_tmp.ApiMenu_Icon
      delete menu_tmp.ApiMenu_Link
      delete menu_tmp.ApiMenu_Image
      axios.post(this.api_tool_url + '/del_menu', menu_tmp, this.config)
        .then(response => {
          this.menus.splice(index, 1)
          this.close()
          })
        .catch(error => {
          this.menus = []
          alert(error.response.data.message)
          })
    },

    close () {
      this.dialog = false
      this.dialog_new = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        axios.post(this.api_tool_url + '/upd_menu', this.editedItem, this.config)
        .then(response => {
          Object.assign(this.menus[this.editedIndex], response.data.ResultRows[0])
          this.close()
          })
        .catch(error => {
          this.menus = []
          alert(error.response.data.message)
          })
        //Object.assign(this.users[this.editedIndex], this.editedItem)
      } else {
        axios.post(this.api_tool_url + '/ins_menu', this.editedItem, this.config)
        .then(response => {
          //console.log(response)
          this.menus.push(response.data.ResultRows[0])
          this.close()
        })
        .catch(error => {
          this.menus = []
          alert(error.response.data.message)
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/MenuGrid.vue